import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PlayCircleFillIcon } from '@yonderland/andes-icons';
import { Icon, PillButton } from '@yonderland/andes-react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { useProductMedia } from './useProductMedia';
export const PlayVideoButton = ({ onClick, size = 'md' }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { mediaCollection } = useProductMedia();
    const videoCount = useMemo(() => mediaCollection.filter(item => item.isVideo).length, [mediaCollection]);
    if (videoCount === 0)
        return null;
    const buttonText = t('pdp.video.count', { count: videoCount });
    return (_jsxs(PillButton, { inverse: true, theme: "branded", variant: "primary", testId: "product-video-button", size: size, onClick: onClick, children: [_jsx(Icon, { source: PlayCircleFillIcon, size: size }), buttonText] }));
};
